import {
    AGENTS_LIST_REQUEST_SUCCESS,
    AGENTS_LIST_REQUEST_FAIL
  } from '../action.types'
  import InitialState from '../initial.state'
  
  export default function(state = InitialState.agents, action) {
    switch (action.type) {
        case AGENTS_LIST_REQUEST_SUCCESS:
          return { ...action.payload };
        case AGENTS_LIST_REQUEST_FAIL:
          return state
      default:
        return state
    }
  }
  


// WEBPACK FOOTER //
// ./src/redux/service/serviceAgents.reducer.js